import type { TAdobeLaunchPayloadStatic } from './types';

export const payload_static: TAdobeLaunchPayloadStatic = {
  property: 'www',
  sub_property: '',
  sub_sub_property: 'pre-qualify for car financing in minutes',
  page_title: 'pre-qualify for car financing in minutes',
  user_id: '',
  br_language: 'en-us',
  web_lang: 'en-us',
  form_name_id: 'marketplace_lf',
  form_type: 'pre-qualify',
  signed_in_status: 'guest',
  account_type: '',
  page_url: 'https://www.creditacceptance.com/get-prequalified/',
  is_spa: true,
};
